// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".todesktop #organisation-splash-wrapper{-webkit-app-region:drag}.todesktop #organisation-splash-wrapper *{-webkit-app-region:no-drag}", ""]);
// Exports
module.exports = exports;
